module.exports = __webpack_public_path__ + "static/media/VU2630F0.3a8b688d.png";